import LocateAddressModal from './LocateAddressModal';

export default LocateAddressModal;